import { Platform, StyleSheet } from 'react-native'

export const landingSectionRevealStyles = StyleSheet.create({
  container: {
    ...(Platform.OS === 'web'
      ? ({
          overflow: 'hidden',
        } as object)
      : {}),
  },
  animatedContent: {
    ...(Platform.OS === 'web'
      ? ({
          willChange: 'transform, opacity',
        } as object)
      : {}),
  },
})
